import type { LoyaltyTier } from '../../../types/gamification.types';

export const getTierRewardPct = (tier?: Pick<LoyaltyTier, 'rewardRates'>): number =>
  Math.round((tier?.rewardRates[0]?.rateValue ?? 0) * 10_000) / 100;
